<template>
  <div>
    <div class="league-hat" style="margin-right: 10px;">
      <active-button
        style="width: 100%;"
        class="league-button"
        :title="league['name_' + $i18n.locale]"
        @click="$router.push(`/prematch/sport/${sport}/league/${league.id}`)"
      >
        <div class="league-name ellipsis">{{$i18n.locale ? league['name_' + $i18n.locale] : league.name }}</div>
      </active-button>
      <div
        class="count"
        @click="$router.push(`/prematch/sport/${sport}/league/${league.id}`)"
      >
        <span style="margin-left: 2px; margin-right: 2px;">{{ league.count }}</span>
      </div>
      <!--icon-button @click="open = !open">
        <arrow-icon :direction="open ? 'up' : 'down'"></arrow-icon>
      </icon-button -->
    </div>
    <div class="list" :class="open ? 'open' : ''">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ActiveButton from '@/components/buttons/ActiveButton'
import IconButton from '@/components/buttons/IconButton'
import ArrowIcon from '@/components/icons/ArrowIcon'

export default {
  components: {
    ActiveButton,
    IconButton,
    ArrowIcon
  },
  props: {
    league: Object,
    sport: Number
  },
  data () {
    return {
      open: false
    }
  }
}
</script>

<style scoped>
.league-hat { display: flex; }
.league-hat .arrow-icon { font-size: 16px; }
.league-hat:hover { background: #d4dbe3 !important; }
.league-button { display: flex; height: 40px; line-height: 40px; }
.league-button:hover { background: none; }
.league-name { padding-left: 8px; width: calc(100% - 40px); }
.league-name { background: none; }
.list { background: rgba(255, 255, 255, .05); display: none; }
.list.open { display: block; }
.count { font-weight: 600; font-size: 13px; width: 30px; text-align: center; margin-right: 10px; line-height: 30px; height: 30px;  margin-top: 5px; border-radius: 5px; cursor: pointer; }
</style>



// WEBPACK FOOTER //
// src/components/sports/main_sport_2/League.vue